import { DateConditions, IntEnumConditions, StringConditions } from '../../../../grid/gridFilters/types';
import { translateFn } from '../../../../utils/translator.helper';
import { ViewConfiguration } from '../../../../grid/gridView/types';
import { ColumnDetails } from '../../../../grid/types/common';

export interface EasmScanConfigurationAssetGridWebComponentSchema {
  response: EASMScanConfigurationAssetGridViewData;
}

export interface EASMScanConfigurationAssetGridViewData {
  views: Array<ViewConfiguration<any, any>>;
  allColumns: Array<ColumnDetails<any, any>>;
  defaultViewProps: ViewConfiguration<any, any>;
}

export enum Column {
  VALUE,
  TYPE,
  DATE_ADDED,
  ACTIONS,
}

export enum ColumnKeys {
  VALUE = 'value',
  TYPE = 'type',
  DATE_ADDED = 'dateAdded',
  ACTIONS = 'actions',
}

export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.VALUE, ColumnKeys.TYPE, ColumnKeys.DATE_ADDED];

export enum AssetType {
  IPv4 = 6,
  IPv6 = 7,
  EMAIL = 8,
  DOMAIN = 2,
}

export interface AssetListsResponse {
  include: Array<DataGridItem>;
  exclude: Array<DataGridItem>;
}

export interface DataGridItem {
  value: string;
  type: AssetType;
  dateAdded: string;
  id: string;
  actions: string;
  isNowAdded?: boolean;
}

export interface Filter {
  assetName?: StringConditions;
  assetType?: IntEnumConditions;
  dateAdded?: DateConditions;
}

export interface SetFiltersRequest {
  viewId: string;
  filters: Array<Filter>;
}

export interface GetDataGridItemsResponse {
  rawEvents?: Array<DataGridItem>;
}

export interface AssetTypeConfig {
  label: string;
  value: AssetType;
  disabled?: boolean;
  selected?: boolean;
}

export function getAssetTypeValues(): Array<AssetTypeConfig> {
  return [
    {
      label: translateFn('IPv4'),
      value: AssetType.IPv4,
    },
    {
      label: translateFn('IPv6'),
      value: AssetType.IPv6,
    },
    {
      label: translateFn('Email'),
      value: AssetType.EMAIL,
    },
    {
      label: translateFn('Domain'),
      value: AssetType.DOMAIN,
    },
  ];
}

export enum GridType {
  SCAN_LIST,
  SCAN_EXCLUSIONS,
}
